module.exports = __webpack_public_path__ + "static/media/trial1_2.6288c324.png";